import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./DetailedTicket.css";

const DetailedTicket = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { ticket, customerName, customerEmail, customerPhone } =
    location.state || {};

  const handleTakeActionClick = () => {
    navigate("/admin/dashboard/ticket-response", {
      state: { ticket, customerName, customerEmail, customerPhone },
    });
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className="detailed-ticket">
      <h2>Detailed Ticket</h2>
      <table className="details-table">
        <tbody>
          <tr>
            <td>Customer Name</td>
            <td>{customerName}</td>
          </tr>
          <tr>
            <td>Email ID</td>
            <td>{customerEmail}</td>
          </tr>
          <tr>
            <td>Phone Number</td>
            <td>{customerPhone}</td>
          </tr>
          <tr>
            <td>Subject</td>
            <td>{ticket.subject}</td>
          </tr>
          <tr>
            <td>Issue Type</td>
            <td>{ticket.issue_type || "N/A"}</td>
          </tr>
          <tr>
            <td>Priority Level</td>
            <td>{ticket.priority_level}</td>
          </tr>
          <tr>
            <td>Description</td>
            <td>{ticket.description}</td>
          </tr>
          {ticket.attachment_url && (
            <tr>
              <td>Attachment</td>
              <td>
                <a
                  href={ticket.attachment_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Attachment
                </a>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <button className="take-action-button" onClick={handleTakeActionClick}>
        Take Action
      </button>
      <button className="back-button" onClick={handleBackClick}>
        Back
      </button>
    </div>
  );
};

export default DetailedTicket;
